import React from 'react';
import './styles/partners.css'
import './styles/about.css'
import Ashley from '../assets/HHAshley-17.jpg';
import Angie from '../assets/WhatsApp Image 2025-11-23 at 10.45.22 PM.jpeg';
import Madison from '../assets/c96a6cbd-3100-4c58-bf14-d041a37a9700.jpg';
import Keerthana from '../assets/IMG_3247.jpeg';
import { Link } from 'react-router-dom';

export default function Home() {
    return (
        <section className="partner-landing about-section general">

            <img src={Angie} alt="" className="me" />

            <p className="aboutIntro">
                <h2>Angie Cole</h2>
                <br />
                (she/her)
                <br />
                Master of Social Work
                <br />
                Registered Social Worker
                <br />
            </p>

            <p className="aboutText">
                Hi, I’m Angie — a Social Worker passionate about supporting teens, women, and families through life’s toughest moments. As a mother, and someone personally touched by loss, mental health struggles, and trauma, I understand how complex, transformative, and challenging life can feel. These experiences guide my work — with empathy, honesty, and hope — helping others find meaning and even joy while navigating grief and life’s challenges.
                <br />
                <br />
                I’ve spent nearly two decades supporting teens, young adults, women, and families facing mental health challenges, trauma, separation, and crises. I focus on helping people feel safer, seen, and more resilient during times of change, loss, or stress.
                <br />
                <br />
                My approach is practical, collaborative, and flexible. Together, we’ll explore your story, discover your strengths, and find ways to cope and grow. Fluent in English and French, I aim to create a warm, welcoming space where teens, women, mothers, and families feel supported, heard, and empowered.

                </p>

            <div className="createSesh">
                <Link to="https://inbloomtherapy.janeapp.com/#/staff_member/2" target="_blank">
                    Create Appointment
                </Link>
            </div>

            <img src={Keerthana} alt="" className="me" />

            <p className="aboutIntro">
                <h2>  Keerthana Baskaran  </h2>
                <br />
                (she/her)
                <br />
                Master of Social Work
                <br />
                Registered Social Worker
                <br />
                <br />
            </p>




            <p className="aboutText">
                Hi, I’m Keerthana, a therapist who works with teens and young adults navigating anxiety, depression, life changes, self-esteem, confidence, and the ups and downs that come with growing up. I know it can feel like no one really gets it - the overthinking, the pressure to have it all figured out, and the constant feeling of not being good enough.                 <br />
                <br />
                I use tools from CBT and DBT to help you manage big emotions, challenge unhelpful thoughts, and build skills that actually work in real life. At the same time, I take a trauma-informed and attachment-based approach - we’ll explore what’s underneath the surface and help you understand why you feel the way you do. 
                <br />
                <br />
                Whether you are feeling lost, stuck, or just need someone to talk to who won’t judge, you don’t have to go through it alone. Even when it doesn’t feel like it, healing and hope are always possible. You don’t have to have it all figured out right now - we will take it one step at a time, together. 
                <br />
                <br />
                Together we’ll work on helping you feel more grounded, confident, and in control of your life again - one session at a time. 
                <br />
                <br />
            </p>

            <div className="createSesh">
                <Link to="https://inbloomtherapy.janeapp.com/#/staff_member/3" target="_blank">
                    Create Appointment
                </Link>
            </div>

        </section>
    );
}